var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBrowser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b85e2bf0-3a2f-4cc2-ae5f-60fe5881a2a5",
    x1: 9,
    y1: 15.834,
    x2: 9,
    y2: 5.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bedd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#32caea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#32d2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#32d4f5"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MsPortalFx.base.images-15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e3e31333-31f4-40d8-9886-d3a1c58d7679"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.5,5.788h17a0,0,0,0,1,0,0v9.478a.568.568,0,0,1-.568.568H1.068A.568.568,0,0,1,.5,15.266V5.788A0,0,0,0,1,.5,5.788Z",
    fill: "url(#b85e2bf0-3a2f-4cc2-ae5f-60fe5881a2a5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.071,2.166H16.929a.568.568,0,0,1,.568.568V5.788a0,0,0,0,1,0,0H.5a0,0,0,0,1,0,0V2.734A.568.568,0,0,1,1.071,2.166Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.787,
    y: 3.248,
    width: 12.426,
    height: 1.459,
    rx: 0.284,
    fill: "#f2f2f2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrowser);
export default __webpack_public_path__ + "static/media/icon-browser.0b85aff5a0978abbd72508084eebbfa2.svg";
export { ForwardRef as ReactComponent };